import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { PageMoveService } from 'src/app/service/page-move.service';

@Component({
  selector: 'app-recruit-list',
  templateUrl: './recruit-list.component.html',
  styleUrls: ['./recruit-list.component.css']
})
export class RecruitListComponent implements OnInit {

  recruits:Array<any> = [];


  constructor(
    private apiService:ApiService,
    private pageMove:PageMoveService,
    private cdr: ChangeDetectorRef
) { }

  ngOnInit(): void {

    this.apiService.getRecruitData()
    .then((resp:any) =>{
      this.recruits = resp;
      this.cdr.detectChanges();
    })
  }

  showDetail(recruit:any){
    this.pageMove.goRecruitDetail(recruit);
  }

}
